import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Layout from './components/Layout';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import WhatsAppEdevcodeLanding from './pages/WhatsAppEdevcodeLanding';
import WhatsAppEdevcodePrivacy from './pages/WhatsAppEdevcodePrivacy';
import WhatsAppEdevcodeTerms from './pages/WhatsAppEdevcodeTerms';
import Convite from './pages/Convite';

function App() {
  useEffect(() => {
    Aos.init({
      once: true,
    });
  }, []);
  return (
    <Routes>
      <Route path="/maria-cecilia" element={<Convite />} />
      <Route path="/whatsapp" element={<WhatsAppEdevcodeLanding />} />
      <Route
        path="/whatsapp/politica-de-privacidade"
        element={<WhatsAppEdevcodePrivacy />}
      />
      <Route
        path="/whatsapp/termos-de-servico"
        element={<WhatsAppEdevcodeTerms />}
      />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
      </Route>
    </Routes>
  );
}

export default App;
